import { Hardware } from './codes';

const keys: Record<string, readonly [number, number]> = {
  ArrowLeft: [Hardware.LEFT_DOWN, Hardware.LEFT_UP],
  ArrowRight: [Hardware.RIGHT_DOWN, Hardware.RIGHT_UP],
  ArrowDown: [Hardware.DOWN_DOWN, Hardware.DOWN_UP],
  ArrowUp: [Hardware.ROTATE_CW_DOWN, Hardware.ROTATE_CW_UP],
  KeyX: [Hardware.ROTATE_CW_DOWN, Hardware.ROTATE_CW_UP],
  KeyZ: [Hardware.ROTATE_CCW_DOWN, Hardware.ROTATE_CCW_UP],
  Space: [Hardware.HARD_DROP_DOWN, Hardware.HARD_DROP_UP],
  KeyC: [Hardware.HOLD_DOWN, Hardware.HOLD_UP],
  KeyP: [Hardware.PAUSE_DOWN, Hardware.PAUSE_UP],
  Escape: [Hardware.PAUSE_DOWN, Hardware.PAUSE_UP],
  KeyR: [Hardware.RESTART_DOWN, Hardware.RESTART_UP],
  Enter: [Hardware.START_DOWN, Hardware.START_UP],
};

export function installKeyboard(send: (code: number) => void): () => void {
  const pressed = new Set<string>();
  const down = (event: KeyboardEvent) => {
    const mapping = keys[event.code];
    if (!mapping) return;
    event.preventDefault();
    if (event.repeat || pressed.has(event.code)) return;
    pressed.add(event.code);
    send(mapping[0]);
  };
  const up = (event: KeyboardEvent) => {
    const mapping = keys[event.code];
    if (!mapping) return;
    event.preventDefault();
    pressed.delete(event.code);
    send(mapping[1]);
  };
  const releaseAll = () => {
    for (const code of pressed) send(keys[code][1]);
    pressed.clear();
  };
  window.addEventListener('keydown', down);
  window.addEventListener('keyup', up);
  window.addEventListener('blur', releaseAll);
  return () => {
    releaseAll();
    window.removeEventListener('keydown', down);
    window.removeEventListener('keyup', up);
    window.removeEventListener('blur', releaseAll);
  };
}
